import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { KpiService } from "../../kpi/kpi.service";
import { View, Group, EfficacyCriteria } from "../../store/students/state";
import { UnsavedChangesConfirmModalComponent } from "../unsaved-changes-confirm-modal/unsaved-changes-confirm-modal.component";

import * as _ from "lodash";
import { List } from "../../shared/interfaces";

@Component({
  selector: "app-list-settings-modal",
  templateUrl: "./list-settings-modal.component.html",
  styleUrls: ["./list-settings-modal.component.scss"],
})
export class ListSettingsModalComponent {
  selectedSettingsItem: any; // can be view or group
  error: string;
  isSaveSuccessful: boolean;
  hasChangesToSave: boolean;
  updatedView: View;
  newView: View;
  newGroup: Group;
  updatedGroup: Group;
  selectedSettingsItemType: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private kpiService: KpiService,
    public dialogRef: MatDialogRef<ListSettingsModalComponent>,
    public dialog: MatDialog
  ) {
    this.data.groups =
      this.data.groups && this.data.groups.length > 0
        ? _.orderBy(
            this.data.groups,
            [
              (group) => group["isSharedWithMe"],
              (group) =>
                group["name"] ? group["name"].toLowerCase() : group["name"],
            ],
            ["asc", "asc"]
          )
        : [];
    this.data.userViews =
      this.data.userViews && this.data.userViews.length > 0
        ? _.orderBy(
            this.data.userViews,
            [
              (view) => view["isSharedWithMe"],
              (view) =>
                view["name"] ? view["name"].toLowerCase() : view["name"],
            ],
            ["asc", "asc"]
          )
        : [];
    if (this.data.initiallySelectedItem) {
      this.selectedSettingsItem = this.data.initiallySelectedItem;
    } else if (this.data.type == "group") {
      this.newGroup = _.find(this.data.groups, ["id", null]);
      if (this.newGroup) {
        this.selectedSettingsItem = this.newGroup;
      } else {
        this.selectedSettingsItem =
          this.data.groups && this.data.groups.length > 0
            ? this.data.groups[0]
            : null;
      }
    } else if (this.data.type == "view") {
      if (this.data.userViews && this.data.userViews.length > 0) {
        this.newView = _.find(this.data.userViews, ["id", null]);
        if (this.newView) {
          this.selectedSettingsItem = this.newView;
        } else {
          this.selectedSettingsItem =
            this.data.userViews && this.data.userViews > 0
              ? this.data.userViews[0]
              : null;
        }
      }
    } else {
      // if group or view isn't selected, select the first group as first item
      this.selectedSettingsItem =
        this.data.groups && this.data.groups.length > 0
          ? this.data.groups[0]
          : null;
      if (this.selectedSettingsItem == null)
        this.selectedSettingsItem = this.data.userViews[0];
    }
    this.selectedSettingsItemType = _.has(
      this.selectedSettingsItem,
      "efficacyCriteria"
    )
      ? "group"
      : "view";
  }

  ngOnInit() {}

  closeModal() {
    if (this.hasChangesToSave) {
      let dialogRef2 = this.dialog.open(UnsavedChangesConfirmModalComponent, {
        width: "40rem",
        data: {
          title:
            (this.newView
              ? "New View - "
              : this.newGroup
              ? "New Group - "
              : "") + "Unsaved Changes",
          description:
            (this.newView
              ? "Your new view has changes which have not been saved. "
              : this.newGroup
              ? "New Group - "
              : "") +
            "Please save or discard your changes before navigating away from this page.",
        },
      });
      dialogRef2.afterClosed().subscribe((result) => {
        if (result == "save") {
          if (this.selectedSettingsItemType == "group") {
            this.saveGroup(this.updatedGroup, null, true);
          } else {
            this.saveView(this.updatedView, null, true);
          }
        } else if (result == "discard") {
          this.dialogRef.close({
            views: this.data.userViews,
            groups: this.data.groups,
          });
        }
      });
    } else {
      this.dialogRef.close({
        views: this.data.userViews,
        groups: this.data.groups,
      });
    }
  }

  settingsItemSelected(item) {
    if (this.hasChangesToSave) {
      let dialogRef2 = this.dialog.open(UnsavedChangesConfirmModalComponent, {
        width: "40rem",
        data: {
          title: "Unsaved changes",
          description:
            "Please save or discard your changes before navigating away from this page.",
        },
      });
      dialogRef2.afterClosed().subscribe((result) => {
        if (result == "save") {
          if (this.selectedSettingsItemType == "group") {
            this.saveGroup(this.updatedGroup, item);
          } else {
            this.saveView(this.updatedView, item);
          }
        } else if (result == "discard") {
          this.selectNewViewOrGroup(item);
        }
      });
    } else {
      this.selectNewViewOrGroup(item);
    }
  }

  selectNewViewOrGroup(item) {
    this.selectedSettingsItem = item;
    this.selectedSettingsItemType = _.has(
      this.selectedSettingsItem,
      "efficacyCriteria"
    )
      ? "group"
      : "view";
    this.isSaveSuccessful = null;
    this.error = null;
    this.hasChangesToSave = false;
  }

  deleteView(view) {
    this.isSaveSuccessful = null;
    this.error = null;
    this.kpiService.deleteView(view).subscribe(
      (data) => {
        _.remove(this.data.userViews, { id: view.id });
        if (this.data.userViews) {
          this.selectedSettingsItem = this.data.userViews[0];
          this.selectedSettingsItemType = "view";
        }
      },
      (err) => {
        this.error = err;
        console.error(err);
      }
    );
  }

  deleteGroup(group) {
    this.isSaveSuccessful = null;
    this.error = null;
    this.kpiService.deleteGroup(group).subscribe(
      (data) => {
        _.remove(this.data.groups, { id: group.id });
        if (this.data.groups) {
          this.selectedSettingsItem = this.data.groups[0];
          this.selectedSettingsItemType = "group";
        }
      },
      (err) => {
        this.error = err;
        console.error(err);
      }
    );
  }

  saveView(updatedView, itemToNavigate?, closeModal?) {
    this.isSaveSuccessful = null;
    this.error = null;
    if (updatedView.id == null) {
      this.kpiService.addView(updatedView).subscribe(
        (data) => {
          this.data.userViews = _.map(this.data.userViews, (userView: View) => {
            return userView.id == null ? data : userView;
          });
          this.dialogRef.close({
            views: this.data.userViews,
            groups: this.data.groups,
          }); // update the list of userViews and close the modal
        },
        (err) => {
          this.handleSaveError(err);
        }
      );
    } else {
      this.kpiService.updateView(updatedView).subscribe(
        (data: List) => {
          this.data.userViews = _.map(this.data.userViews, (userView: View) => {
            return userView.id == data.id ? data : userView;
          });
          if (itemToNavigate) {
            this.selectedSettingsItem = itemToNavigate;
            this.selectedSettingsItemType = _.has(
              this.selectedSettingsItem,
              "efficacyCriteria"
            )
              ? "group"
              : "view";
          } else if (closeModal) {
            this.dialogRef.close({
              views: this.data.userViews,
              groups: this.data.groups,
            });
          } else {
            this.isSaveSuccessful = true; // only show the view save success message if we haven't navigated away
            this.selectedSettingsItem = updatedView;
          }
          this.hasChangesToSave = false;
        },
        (err) => {
          this.handleSaveError(err);
        }
      );
    }
  }

  saveGroup(updatedGroup, itemToNavigate?, closeModal?) {
    updatedGroup = this.mapEfficacyCriteriaForGroup_snakeToCamel(updatedGroup);
    this.isSaveSuccessful = null;
    this.error = null;
    if (updatedGroup.id == null) {
      this.kpiService.addGroup(updatedGroup).subscribe(
        (data) => {
          data = this.mapEfficacyCriteriaForGroup_camelToSnake(data);
          this.data.groups = _.map(this.data.groups, (group: Group) => {
            return group.id == null ? data : group;
          });
          this.dialogRef.close({
            views: this.data.userViews,
            groups: this.data.groups,
          }); // update the list of userViews and close the modal
        },
        (err) => {
          this.handleSaveError(err);
        }
      );
    } else {
      this.kpiService.updateGroup(updatedGroup).subscribe(
        (data: List) => {
          data = this.mapEfficacyCriteriaForGroup_camelToSnake(data);
          this.data.groups = _.map(this.data.groups, (group: Group) => {
            return group.id == data.id ? data : group;
          });
          if (itemToNavigate) {
            this.selectedSettingsItem = itemToNavigate;
            this.selectedSettingsItemType = _.has(
              this.selectedSettingsItem,
              "efficacyCriteria"
            )
              ? "group"
              : "view";
          } else if (closeModal) {
            this.dialogRef.close({
              views: this.data.userViews,
              groups: this.data.groups,
            });
          } else {
            this.isSaveSuccessful = true; // only show the view save success message if we haven't navigated away
            this.selectedSettingsItem = data;
          }
          this.hasChangesToSave = false;
        },
        (err) => {
          this.handleSaveError(err);
        }
      );
    }
  }

  handleSaveError(err) {
    this.isSaveSuccessful = false;
    this.error = err;
    console.error(err);
  }

  updateChangesToSave(event) {
    this.hasChangesToSave = event;
  }

  updatedItemChange(event) {
    this.selectedSettingsItemType == "group"
      ? (this.updatedGroup = event)
      : (this.updatedView = event);
  }

  mapEfficacyCriteriaForGroup_snakeToCamel(group) {
    return {
      ...group,
      efficacyCriteria: _.map(
        group.efficacyCriteria,
        (criteria: EfficacyCriteria) => {
          return {
            studentKpiId: criteria.student_kpi_id,
            minValue: criteria.min_value,
            maxValue: criteria.max_value,
          };
        }
      ),
    };
  }

  mapEfficacyCriteriaForGroup_camelToSnake(group) {
    return {
      ...group,
      efficacyCriteria: _.map(group.efficacyCriteria, (criteria: any) => {
        return {
          student_kpi_id: criteria.studentKpiId,
          min_value: criteria.minValue,
          max_value: criteria.maxValue,
        };
      }),
    };
  }
}
